'use client'

import { useMemo } from 'react'
import { useIsDesktop } from '@repo/ui/hooks'
import { DepositOnlinePaymentCTA } from './online-payment/deposit-online-payment.cta'
import { DepositCTA } from './deposit.cta'
import { usePathname } from '@repo/shared/i18n/navigation'

export const WalletDepositHeaderLayout = () => {
  const pathname = usePathname()

  const routeItems = [
    {
      component: <DepositOnlinePaymentCTA origin='layout' />,
      link: '/wallet/deposit/online-payment',
    },
    {
      component: <DepositCTA origin='layout' />,
      link: '/wallet/deposit',
    },
  ]
  const isDesktop = useIsDesktop()
  const activeIndex = useMemo(() => {
    return routeItems.findIndex((route) => pathname?.includes(route.link))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
  return !isDesktop ? routeItems[activeIndex]?.component : undefined
}
